const { forEach } = Array.prototype;

module.exports = function (page, popstate) {
    document.documentElement.classList.remove('is-leaving')
    document.documentElement.classList.add('is-rendering')

    let fakeDom = document.createElement('div')
    fakeDom.innerHTML = page.originalContent
    for (var i = 0; i < this.elements.length; i++) {
        if (fakeDom.querySelector(this.elements[i]) == null) {
            console.warn(`Element to be replaced (${this.elements[i]}) is not found in received page.`)
        } else if (document.body.querySelector(this.elements[i]) == null) {
            console.warn(`Element to be replaced (${this.elements[i]}) is not found current html.`)
        } else {
            [].forEach.call(document.body.querySelectorAll(this.elements[i]), (item, index) => {
                if (item.outerHTML != fakeDom.querySelectorAll(this.elements[i])[index].outerHTML) {
                    item.outerHTML = fakeDom.querySelectorAll(this.elements[i])[index].outerHTML
                }
            })
        }
    }

    // set title
    document.title = page.title;

    this.triggerEvent('contentReplaced')
    this.triggerEvent('pageView')
    setTimeout(() => {
        document.documentElement.classList.remove('is-animated')
    }, 10)

    // handle classes after render
    if (this.pageClassPrefix !== false) {
        document.body.className.split(' ').forEach(className => {
            if (className.includes(this.pageClassPrefix)) {
                document.body.classList.remove(className)
            }
        })
    }

    page.pageClass.split(' ').forEach(function (className) {
        document.body.classList.add(className)
    })

    // scrolling
    if (!this.doScrollingRightAway) {
        this.doScrolling(popstate)
    }

    // detect animation end
    let animatedElements = document.querySelectorAll(this.animationSelector)
    let promises = [];
    animatedElements
        ::forEach(element => {
        var promise = new Promise(resolve => {
            element.addEventListener(this.transitionEnd, resolve)
        });
        promises.push(promise)
    });

    Promise
        .all(promises)
        .then(() => {
            this.triggerEvent('animationInDone')
            // remove special classes for specific pages
            for (var i = 0; i <  this.specialPages.length; i++) {
                document.documentElement.classList.remove(this.specialPages[i].class)
            }
            document.documentElement.classList.remove('is-changing')
            document.documentElement.classList.remove('is-rendering')
            document.documentElement.classList.remove('to-' + this.classify(page.url))
        })

    // update current url
    this.getUrl();
}


// WEBPACK FOOTER //
// ./core/xhr2/modules/renderPage.js